import { useRef } from 'react';

// 📌 W2c's pins arrive on EVERY status poll as a NEW array (the same three
// pins, a new identity), so anything memoized on them (`portedPinnedLines`,
// then `placeLine`, then every memoized feed row for the owner) re-rendered
// on every poll (PORTED_HOME_HANDOFF §0-septies.1 item 3). The fix: a value
// keeps its identity while its KEY (what it says) is unchanged.
//
// pinsKey: "id|at|text" per pin, joined; '' for no pins. The `at` stamp is in
// the key because linePinState reads it against `pins_heard_at`, and the text
// because the board draws it (a server-corrected text must still re-render).
export function pinsKey(pins) {
  if (!Array.isArray(pins) || !pins.length) return '';
  return pins.map((p) => (p ? `${p.id}|${p.at || ''}|${String(p.text || '')}` : '')).join('\u001f');
}

// The previous value stays while keyFn(value) is unchanged: identity-stable
// input for useMemo/React.memo. Hooks-safe (one ref), pure between renders.
export function useStableByKey(value, keyFn) {
  const ref = useRef({ key: undefined, value });
  const key = keyFn(value);
  if (ref.current.key !== key) ref.current = { key, value };
  return ref.current.value;
}
